<template>
  <div>
    <Widget>
      <h2 class="page-title text-center">Detail Rencana Aksi Pusat</h2>
      <form-wizard shape="tab" color="#3498db" title="" subtitle="" @on-change="updateProgress">
        <b-button slot="prev" id="prev-rencana-aksi-form" variant="primary" hidden />
        <b-button slot="next" id="next-rencana-aksi-form" variant="primary" hidden />
        <b-button slot="finish" id="finish-rencana-aksi-form" variant="success" hidden />

        <tab-content title="Rencana Aksi">
          <formRencanaAksi
            ref="formRencanaAksi"
            :read-only="!isEditingRencanaAksi"
            :rencana-aksi-id="$route.params.id"
            @submitting="isSubmitting = $event"
            @loaded="rencanaAksi = $event"
          />
        </tab-content>
        <tab-content title="Dokumen Persiapan">
          <formDokumenPersiapan
            ref="formDokumenPersiapan"
            :rencana-aksi-id="$route.params.id"
            :document-ids="documentIds"
            @saved="reloadRencanaAksi"
          />
        </tab-content>

        <div class="d-flex justify-content-between" style="padding: 14px 20px">
          <b-button
            v-if="progress === 1"
            variant="danger"
            class="text-white"
            @click="$router.push('/app/rencana-aksi/pusat')"
          >
            Kembali
          </b-button>
          <b-button v-else variant="primary" @click="prevForm">
            <i class="fa fa-caret-left" /> Tab Sebelumnya
          </b-button>

          <div v-if="progress === 1" class="d-flex align-items-center gap-2">
            <template v-if="hasRole(user, 'Verifikator')">
              <b-button v-if="!isEditingRencanaAksi" type="button" variant="warning" @click="startEditRencanaAksi">
                Edit <i class="fa fa-pencil" />
              </b-button>
              <template v-else>
                <b-button type="button" variant="secondary" @click="cancelEditRencanaAksi">Batal</b-button>
                <b-button type="button" variant="success" :disabled="isSubmitting" @click="saveEditRencanaAksi">
                  Simpan Perubahan <i class="fa fa-check" />
                </b-button>
              </template>
            </template>
            <b-button type="button" variant="primary" :disabled="isEditingRencanaAksi" @click="nextForm">
              Tab Selanjutnya <i class="fa fa-caret-right" />
            </b-button>
          </div>
          <b-button v-else variant="success" @click="submitForm"> Simpan <i class="fa fa-check" /> </b-button>
        </div>
      </form-wizard>
    </Widget>
  </div>
</template>

<style scoped>
:deep(.wizard-header) {
  display: none;
}

:deep(.wizard-nav li) {
  pointer-events: none;
}
</style>

<script>
import Vue from 'vue'
import Widget from '@/components/Widget/Widget'
import formRencanaAksi from './formRencanaAksi.vue'
import formDokumenPersiapan from './formDokumenPersiapan.vue'
import { Validator } from 'vee-validate'
import { hasRole } from '@/helper/helpernew'

export default {
  components: { Widget, formRencanaAksi, formDokumenPersiapan },
  data() {
    return {
      user: JSON.parse(localStorage.getItem('userPengendalian') || '{}') || {},
      progress: 1,
      isEditingRencanaAksi: false,
      isSubmitting: false,
      rencanaAksiBeforeEdit: null,
      rencanaAksi: null,
    }
  },
  computed: {
    documentIds() {
      const data = this.rencanaAksi || {}
      return {
        file_undangan_persiapan: data.id_file_undangan_persiapan || null,
        file_undangan_kegiatan: data.id_file_undangan_kegiatan || null,
        file_kak: data.id_file_kak || null,
        file_desk_study: data.id_file_desk_study || null,
        file_surat_tugas: data.id_file_surat_tugas || null,
        file_data_drone: data.id_file_data_drone || null,
      }
    },
  },
  mounted() {
    const dictionary = {
      id: {
        messages: {
          required: (fieldName) => `${fieldName} wajib diisi`,
          email: () => 'Email tidak valid',
        },
      },
    }
    Validator.localize(dictionary)
    this.$validator.localize('id')
    Validator.extend('pilih_prioritas', {
      getMessage: (fieldName) => `${fieldName} wajib diisi`,
      validate: (value) => value === true || value === false,
    })
  },
  methods: {
    hasRole,

    updateProgress(prevIndex, nextIndex) {
      if (nextIndex >= 0) Vue.set(this, 'progress', nextIndex + 1)
    },
    nextForm() {
      if (this.isEditingRencanaAksi) return
      document.getElementById('next-rencana-aksi-form').click()
    },
    prevForm() {
      document.getElementById('prev-rencana-aksi-form').click()
    },
    async submitForm() {
      if (this.isEditingRencanaAksi) return
      if (await this.$refs.formDokumenPersiapan.saveDokumenPersiapan()) {
        this.$router.push('/app/rencana-aksi/pusat')
      }
    },
    async reloadRencanaAksi() {
      await this.$refs.formRencanaAksi.loadRencanaAksi()
    },
    startEditRencanaAksi() {
      this.rencanaAksiBeforeEdit = this.$refs.formRencanaAksi.getFormData()
      this.isEditingRencanaAksi = true
    },
    async saveEditRencanaAksi() {
      const isSaved = await this.$refs.formRencanaAksi.saveRencanaAksi()
      if (!isSaved) return

      this.isEditingRencanaAksi = false
      this.rencanaAksiBeforeEdit = null
    },
    async cancelEditRencanaAksi() {
      this.isEditingRencanaAksi = false
      await this.$refs.formRencanaAksi.setFormData(this.rencanaAksiBeforeEdit)
      this.rencanaAksiBeforeEdit = null
    },
  },
}
</script>
